import React, { useState, useEffect } from "react";
import "./PaymentMilestones.css";

const PaymentMilestones = ({ milestones }) => {
  const [animationProgress, setAnimationProgress] = useState(0);

  useEffect(() => {
    // Animation on component mount
    const timer = setTimeout(() => {
      setAnimationProgress(100);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  if (!milestones || !Array.isArray(milestones) || milestones.length === 0) {
    return null;
  }

  // Calculate total amount
  const totalAmount = milestones.reduce(
    (sum, milestone) => sum + parseFloat(milestone.totalAmount || 0),
    0
  );

  // Sort milestones by percentage
  const sortedMilestones = [...milestones].sort(
    (a, b) => parseInt(a.percentage || 0) - parseInt(b.percentage || 0)
  );

  // Calculate cumulative positions for each milestone
  let cumulativePercentage = 0;
  const adjustedMilestones = sortedMilestones.map((milestone) => {
    cumulativePercentage += parseInt(milestone.percentage || 0);
    return {
      ...milestone,
      adjustedPosition: cumulativePercentage,
      startPosition: cumulativePercentage - parseInt(milestone.percentage || 0),
    };
  });

  // Format currency with commas
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <div className="payment-milestones-container">
      <div className="milestone-title">Payment Milestones</div>
      <div className="payment-header">
        <div className="amount-section">
          <div className="allotted-amount">
            <span className="label">ALLOTTED AMOUNT</span>
            <span className="value">₹ {formatCurrency(totalAmount)}</span>
          </div>
        </div>
      </div>

      <div className="milestone-track-container">
        <div className="milestone-track">
          {/* Animated progress bar */}
          <div
            className="milestone-progress"
            style={{ width: `${animationProgress > 0 ? "0" : "0"}%` }}
          ></div>

          {/* Display all milestone markers */}
          {adjustedMilestones.map((milestone, index) => (
            <div
              key={index}
              className="milestone-marker"
              style={{ left: `${milestone.adjustedPosition}%` }}
            >
              <div className="milestone-dot"></div>
              <div className="milestone-info">
                <div className="milestone-name">{milestone.name}</div>
                <div className="milestone-percentage">
                  {milestone.percentage}%
                </div>
                <div className="milestone-amount">
                  ₹{formatCurrency(parseFloat(milestone.totalAmount))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PaymentMilestones;
